var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-form-checkbox',{staticClass:"m-l-20",attrs:{"disabled":_vm.is_disabled},model:{value:(_vm.discount_stock),callback:function ($$v) {_vm.discount_stock=$$v},expression:"discount_stock"}},[_vm._v(" Descontar stock ")])
}
var staticRenderFns = []

export { render, staticRenderFns }